import ParamTable from "./ParamTable";
import React from "react";

const columns = [
  { key: "name", title: "name", required: true },
  { key: "repository_id", title: "repository_id", type: "repository" },
  { key: "depends_on", title: "depends_on", type: "json" },
];

export default function ParamModules() {
  return <ParamTable table="modules" title="Modules" columns={columns} />;
}
